/** Text used by `lib/format` (days, «à» between a day and a time). */
export const fr = {
  days: { one: '{count} jour', other: '{count} jours' },
  dayAtTime: '{day} à {time}',
} as const;
